import { render, staticRenderFns } from "./DeletePostCacheBtn.vue?vue&type=template&id=5b8d5d7e&"
import script from "./DeletePostCacheBtn.vue?vue&type=script&lang=js&"
export * from "./DeletePostCacheBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports